import { render, staticRenderFns } from "./EvaluacionAnualCardComponent.vue?vue&type=template&id=0c645f4a"
import script from "./EvaluacionAnualCardComponent.vue?vue&type=script&lang=js"
export * from "./EvaluacionAnualCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports